module.exports = __webpack_public_path__ + "static/media/AVARIS_Logo_WithLetters_Fixed.17d6fd11.png";